import React, { FC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { GroupLayout } from '@cld/form';
import { messages } from '../../../../i18n';
import { TextLine } from '../../common/TextLine';
import { useExportedQualities } from '../../../../selectors';
import { SelectedExportQualitiesState } from '../../../../types';
import { ExportOptionField } from './ExportOptionField';

export const Quality: FC = () => {
  const { formatMessage } = useIntl();
  const selectedExportQualities = useExportedQualities();

  const selected = Object.keys(selectedExportQualities).filter((item) => selectedExportQualities[item as keyof SelectedExportQualitiesState]);

  return (
    <div>
      <TextLine>
        <FormattedMessage {...messages['section.export.quality']} />
      </TextLine>
      <GroupLayout>
        <ExportOptionField
          label={formatMessage(messages['section.export.quality.auto'])}
          optionPath="selectedExportQualities.auto"
          isDisabled={selected.length === 1 && selected.includes('auto')}
        />
        <ExportOptionField
          label={formatMessage(messages['section.export.quality.best'])}
          optionPath="selectedExportQualities.best"
          isDisabled={selected.length === 1 && selected.includes('best')}
        />
        <ExportOptionField
          label={formatMessage(messages['section.export.quality.good'])}
          optionPath="selectedExportQualities.good"
          isDisabled={selected.length === 1 && selected.includes('good')}
        />
        <ExportOptionField
          label={formatMessage(messages['section.export.quality.eco'])}
          optionPath="selectedExportQualities.eco"
          isDisabled={selected.length === 1 && selected.includes('eco')}
        />
        <ExportOptionField
          label={formatMessage(messages['section.export.quality.low'])}
          optionPath="selectedExportQualities.low"
          isDisabled={selected.length === 1 && selected.includes('low')}
        />
      </GroupLayout>
    </div>
  );
};
